import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <Logo isLight className="mb-4" />
            <p className="text-sm">
              MULTI SERVICE S.R.L.S.<br />
              Via Isonzo 102<br />
              73055 Racale (LE)<br />
              P.IVA / VAT.ID: IT 05316380756<br />
              REA: LE-358063 | c.s.v.: Euro 500
            </p>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">{t('nav.services')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/web-hosting" className="hover:text-white">{t('nav.webHosting')}</Link></li>
              <li><Link to="/vps" className="hover:text-white">{t('nav.vps')}</Link></li>
              <li><Link to="/dedicated" className="hover:text-white">{t('nav.dedicated')}</Link></li>
              <li><Link to="/game-hosting" className="hover:text-white">{t('nav.gameHosting')}</Link></li>
              <li><Link to="/colocation" className="hover:text-white">{t('nav.colocation')}</Link></li>
              <li><Link to="/ip-transit" className="hover:text-white">{t('nav.ipTransit')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">{t('nav.support')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-white">{t('nav.contact')}</Link></li>
              <li><Link to="/faq" className="hover:text-white">{t('nav.faq')}</Link></li>
              <li><Link to="/abuse" className="hover:text-white">Report Abuse</Link></li>
              <li>
                <a 
                  href="https://my.synthohosting.net/login.php" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white"
                >
                  {t('nav.clientArea')}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">{t('legal.title')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="hover:text-white">{t('legal.terms.title')}</Link></li>
              <li><Link to="/privacy" className="hover:text-white">{t('legal.privacy.title')}</Link></li>
              <li><Link to="/cookies" className="hover:text-white">{t('legal.cookies.title')}</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8">
          <p className="text-sm text-center">
            {t('legal.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
}